import React from "react";
import dynamic from "next/dynamic";
import styles from "../../styles/pages/emptwin.module.scss";
const Icons = dynamic(() => import("../../public/assets/svg/index"));
const Card = dynamic(() => import("../dynamicBotCard"));
import Carousels from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import endpoints from "../../utility/endpoints";
const BasicForm = dynamic(() => import("../basicForm"));
const Video = dynamic(() => import("../../pages/videoModal"));
const Empbanner = dynamic(() => import("../emptwinmanageBanner"));
const Emptwinskills = dynamic(() => import("../emptwinskillscart"));
const Filters = dynamic(() => import("../Filtersemptwin"));
import _get from "lodash/get";
import { useRouter } from "next/router";
import ReactPlayer from "react-player";
import axios from "axios";
import { useState, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
const SuccessModal = dynamic(() => import("../../pages/successModal"));
import { useMediaQuery } from "react-responsive";
const Loader = dynamic(() => import("../Loader"));
import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CartModal from "../Pages/Cartmodal";
import { BlobServiceClient } from "@azure/storage-blob";
function index(props) {
  const router = useRouter();
  console.log("props  ------ Employeetwin page  -----", props);

  let initialStates = {};
  let [state, setState] = React.useState(initialStates);
  const [submitForm, setSubmitForm] = React.useState(false);
  const [invalidFlag, setInvalidFlag] = React.useState(false);
  const [getFormValues, setGetFormValues] = React.useState(false);
  const [emptyFormValues, setEmptyFormValues] = React.useState(false);
  const [bots, setBots] = React.useState([]);
  const [successModal, setSuccessModal] = React.useState(false);
  const [cartModal, setCartModal] = React.useState(false);
  const [empdata, setEmpdata] = useState([]);
  const [softskilldata, setSoftskilldata] = useState([]);
  const backgroundUrlMobile = _get(
    props.data[0],
    "component.content.field_background_image_mobile[0]",
    ""
  );
  const backgroundUrl = _get(
    props,
    "data[0]component.content.field_background_image[0].file_url",
    ""
  );

  const emptwinDetails = _get(
    props,
    "data[0].component.content.field_details",
    ""
  );
  const emptwinHeading = _get(
    props,
    "data[0]component.content.field_hedaing",
    ""
  );
  const backgroundUrlMobile1 = _get(
    props.data[10],
    "component.content.field_background_image_mobile[0]",
    ""
  );
  const backgroundUrl1 = _get(
    props,
    "data[10]component.content.field_background_image[0].file_url",
    ""
  );
  const backgroundUrl11 = _get(
    props,
    "data[0].component.content.field_background_image[1].file_url",
    ""
  );
 console.log('backgroundUrl11',backgroundUrl11);
// console.log('getting all images',props.data[0].component.content.field_background_image[1].file_url);
  const emptwinDetails1 = _get(
    props,
    "data[10].component.content.field_details",
    ""
  );
  const emptwinHeading1 = _get(
    props,
    "data[10]component.content.field_hedaing",
    ""
  );
  const backgroundUrlMobileemptwin = _get(
    props.data[11],
    "component.content.field_background_image_mobile[0]",
    ""
  );
  const backgroundUrlemptwin = _get(
    props,
    "data[11]component.content.field_background_image[0].file_url",
    ""
  );



  const goTo = (link) => {
    // console.log(link);
    router.push(link);
  };
  function openpopup()
  {
    let modal = !cartModal;
    setCartModal(true);
    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }


  const moveToCez = (sectionName) => {
    router.push({
      pathname: props.pageRoutes.CognitiveExperienceZone,
      query: { cezSection: sectionName },
    });
  };
  
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const empid = params.get('empTwinId');
 console.log(empid);
 localStorage.setItem('empid', JSON.stringify(empid));

  const reactRef = React.useRef(null);
  const localHandler = async (e) => {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    const { data } = await axios({
      url: `${endpoints.baseUrl}/twin/search?empTwinId=ET00001`,
      method: "GET",
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },
    });
    console.log(data);
    if (data.code === 200) {
      setEmpdata(data.allSkill[0]);
      setSoftskilldata(data.softSkill);
    }
    else
    {
      console.log("No data found")
    }
  
}

React.useEffect(() => {
  localHandler();
},[])

console.log(empdata);
let auth =  JSON.parse(localStorage.getItem("auth")).data;
console.log(auth.email);

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const previousMonthindex = currentDate.getMonth() === 0 ? 11 : currentDate.getMonth()-1;
const montharray=["January", "February", "March", "April", "May", "June", "July", "August", "September","October", "November", "December"];
const previousMonth=montharray[previousMonthindex]
const [months,setMonths]=useState(previousMonth);

const onValueChange = async (e) => {
  const value = e.target.value;
  console.log(e.target.id,e.target.value);
    setMonths(e.target.value);
     const { data } = await axios({
    url: `${endpoints.baseUrl}/twin/getmanagetwin/${year}/${e.target.value}`,
    method: "GET",
    headers: {
      Authorization: `${auth.accessToken}|${auth.email}`,
    },

  });
  if (data.code === 200) {
        // Filter soft skill data
    const softSkills = data.data.filter(item => item.Skilltype === 'Soft Skill');
    const globalSkills = data.data.filter(item => item.Skilltype === 'Global Skill');
    const localSkills = data.data.filter(item => item.Skilltype === 'Local Skill');
        setSoftskill(softSkills);
        setGlobalskill(globalSkills);
        setLocalskill(localSkills);
  }
  else
  {
    console.log("No data found")
  }

}
const [year,setYear]=useState(currentYear);
const yeararray=["2022", "2023"];

const onValueChangeyear = async (e) => {
  const value = e.target.value;
  console.log(e.target.id,e.target.value);
    setYear(e.target.value);
    if(months.length>0){
    const { data } = await axios({
      url: `${endpoints.baseUrl}/twin/getmanagetwin/${e.target.value}/${months}`,
      method: "GET",
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },
  
    });
    if (data.code === 200) {
          // Filter soft skill data
      const softSkills = data.data.filter(item => item.Skilltype === 'Soft Skill');
      const globalSkills = data.data.filter(item => item.Skilltype === 'Global Skill');
      const localSkills = data.data.filter(item => item.Skilltype === 'Local Skill');
          setSoftskill(softSkills);
          setGlobalskill(globalSkills);
          setLocalskill(localSkills);
    }
    else
    {
      console.log("No data found")
    }
  }
}
const [globalskill,setGlobalskill]=useState([]);
const [localskill,setLocalskill]=useState([]);
const [softskill,setSoftskill]=useState([]);
const skillstat = async (e) => {
  let auth = JSON.parse(localStorage.getItem("auth")).data;
  const { data } = await axios({
    url: `${endpoints.baseUrl}/twin/getmanagetwin/${year}/${months}`,
    method: "GET",
    headers: {
      Authorization: `${auth.accessToken}|${auth.email}`,
    },

  });
  if (data.code === 200) {
        // Filter soft skill data
    const softSkills = data.data.filter(item => item.Skilltype === 'Soft Skill');
    const globalSkills = data.data.filter(item => item.Skilltype === 'Global Skill');
    const localSkills = data.data.filter(item => item.Skilltype === 'Local Skill');
        setSoftskill(softSkills);
        setGlobalskill(globalSkills);
        setLocalskill(localSkills);
  }
  else
  {
    console.log("No data found")
  }

}
React.useEffect(() => {
  skillstat();
},[]);

const [showupload, setShowupload] = useState(false);
const [fileerror, setFileError] = useState(false);
const [filesuccess, setFilesuccess] = useState(false);
const manageskill=()=>{
  setShowupload(true);
}
let azurefilepath;
const blobSasUrlNew = endpoints.blobSasUrlNew;
const blobServiceClient = new BlobServiceClient(blobSasUrlNew);
const containerClient = blobServiceClient.getContainerClient("botstorevideo/employeetwin/emp");

const uploadFile =async  (imageFile) => {
  const originalFileName = imageFile.name;
    let fileName = originalFileName;
    let index = 1;
    while (await containerClient.getBlockBlobClient(fileName).exists()) {
      const extension = originalFileName.substring(originalFileName.lastIndexOf('.'));
      fileName = `${originalFileName.substring(0, originalFileName.lastIndexOf('.'))}_${index}${extension}`;
      index++;
    }
    const blockBlobClient = containerClient.getBlockBlobClient(fileName);
    try {
      await blockBlobClient.uploadBrowserData(imageFile);
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      axios({
          url: `${endpoints.baseUrl}/twin/manageet`,
          method: "POST",
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
          data:{
            filelink:"https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/emp/"+imageFile.name}
        }).then((resp) => {
          console.log(resp);
          
        });
      console.log('Image uploaded successfully!');
      setFilesuccess(true);
    } catch (error) {
     setFileError(true);
      console.error('Error uploading image:', error);
    }
};

const handleFileChange = (event) => {
  setFilesuccess(false);
  const file = event.target.files[0];
  if (file) {
    uploadFile(file);
  }
};

  return (
    <div className={`${styles.landingContainer}`}>
      {successModal ? (
        <SuccessModal
          setSuccessModal={setSuccessModal}
          title={"Request a demo"}
          message={message}
        />
      ) : null}
      <div id="headTop"></div>
      <Empbanner
        data={{
          emptwinDetails,
          emptwinHeading,
          backgroundUrl,
          backgroundUrl11,
          backgroundUrlMobile,
        }}
        name = "employeetwinskills"
        empdata={empdata}
      />
            <div className="container" style={{ padding: "20px" }}>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-12 ">
            <div className={styles.formGroup}>
              <select
                className={styles.select1}
                name="year"
                id="year"
                onChange={onValueChangeyear}
                value={year}
              >
                <option value="All">Select Year</option>
                {yeararray.map(
                  (item, index) => {
                    return (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    );
                  }
                )}
              </select>
              <select
                className={styles.select1}
                name="month"
                id="month"
                onChange={onValueChange}
                value={months}
              >
                <option value="All">Select Month</option>
                {montharray.map(
                  (item, index) => {
                    return (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    );
                  }
                )}
              </select>
            </div>
          </div>
  
        </div>
      </div>
      <div className={`${styles.managetableContainer} container-fluid`}>
        <div className="row">
          <div className={`${styles.manageTable} col-md-12`}>
            <div className={`${styles.manageSkillHeading}`}>
              <h3 className={`${styles.skillHeading} ${styles.softskillHeading}`}>Soft Skill</h3>
            </div>
          <table className={`${styles.manage_table}`}>
          <thead className={`${styles.manage_thead}`}>
            <tr className={`${styles.manage_thead_row} ${styles.soft_thead_row}`}>
              <th>Skill</th>
              <th>No. of User Accessing this Skill</th>
              <th>Number of Hits</th>
              <th>Cost</th>            
            </tr>
          </thead>
          <tbody className={`${styles.manage_tbody} ${styles.soft_tbody}`}>
              {softskill.map((item, index) => {
                                        const {
                                          Cost,
                                          Skill,
                                          usercount,
                                          Hits
                                        } = item;
    
            return(<tr className={`${styles.manage_tbody_row}`}>
              <td>{Skill}</td>
              <td>{usercount}</td>
              <td>{Hits}</td>
              <td>{Cost}</td>
            </tr>)

          })}
            
          </tbody>
        </table>
          </div>
          <div className={`${styles.manageTable} col-md-12`}>
            <div className={`${styles.manageSkillHeading}`}>
              <h3 className={`${styles.skillHeading} ${styles.localskillHeading}`}>Local Skill</h3>
            </div>
          <table className={`${styles.manage_table} ${styles.local_table}`}>
          <thead className={`${styles.manage_thead} ${styles.local_thead}`}>
            <tr className={`${styles.manage_thead_row} ${styles.local_thead_row}`}>
              <th>Skill</th>
              <th>No. of User Accessing this Skill</th>
              <th>Number of Hits</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody className={`${styles.manage_tbody} ${styles.local_tbody}`}>
                {localskill.map((item, index) => {
                                        const {
                                          Cost,
                                          Skill,
                                          usercount,
                                          Hits
                                        } = item;
   
            return(<tr className={`${styles.manage_tbody_row}`}>
              <td>{Skill}</td>
              <td>{usercount}</td>
              <td>{Hits}</td>
              <td>{Cost}</td>
            </tr>)

          })}
          </tbody>
        </table>
          </div>
          <div className={`${styles.manageTable} col-md-12`}>
            <div className={`${styles.manageSkillHeading}`}>
              <h3 className={`${styles.skillHeading} ${styles.globalskillHeading}`}>Global Skill</h3>
            </div>
          <table className={`${styles.manage_table} ${styles.global_table}`} style={{marginBottom:"30px"}}>
          <thead className={`${styles.manage_thead} ${styles.global_thead}`}>
            <tr className={`${styles.manage_thead_row} ${styles.global_thead_row}`}>
            <th>Skill</th>
              <th>No. of User Accessing this Skill</th>
              <th>Number of Hits</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody className={`${styles.manage_tbody} ${styles.global_tbody}`}>
            {globalskill.map((item, index) => {
                                        const {
                                          Cost,
                                          Skill,
                                          usercount,
                                          Hits
                                        } = item;
 
            return(<tr className={`${styles.manage_tbody_row}`}>
              <td>{Skill}</td>
              <td>{usercount}</td>
              <td>{Hits}</td>
              <td>{Cost}</td>
            </tr>)

          })}
          </tbody>
        </table>
          </div>
          </div>
              {/*   {auth.email==empdata.businessOwner ?
 */}       <div className={styles.editdata}>
            <button onClick={manageskill}>Manage Skill Data</button>
            {
              showupload?
             
                  <div className={`${styles.uploadBtnWrapper}`}>
                  
                      <label className={styles.mainLabel}>Upload Excel File</label>
                      <div className={styles.uploadControl}>
                        <input
                          type="file"
                          onChange={(e) => {
                            handleFileChange(e);
                          }}
                          className={styles.fileupload}
                          accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        />
                        {filesuccess ? (
                          <span style={{ color: "#00b190", fontSize: "12px",verticalAlign: "middle",lineHeight: "35px" }}>
                            Uploaded Successfully
                          </span>
                        ) : null}
                        {fileerror ? (
                          <span style={{ color: "red", fontSize: "12px",verticalAlign: "middle",lineHeight: "35px" }}>
                            Error when uploading
                          </span>
                        ) : null}
                      </div>
                   
                  </div>
                
              :null
            }
          </div>
          {/*:null}

*/}        </div>
       
    
        {
        cartModal ? (
          <CartModal
            data={props.softskill.data.field_component}
            closeModal={() => {
              setCartModal(false);
            }}
            pageRoutes={props.pageRoutes}
           
            empid={empid}
          />
        ) : null
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);

